import { render } from "./DashboardLoginModal.vue?vue&type=template&id=07b90808&scoped=true"
import script from "./DashboardLoginModal.vue?vue&type=script&lang=ts"
export * from "./DashboardLoginModal.vue?vue&type=script&lang=ts"

import "./DashboardLoginModal.vue?vue&type=style&index=0&id=07b90808&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-07b90808"

export default script